<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/community_manager/wip"
      *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager')">Wip</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/designer/wip"
      *ngIf="role=='designer'">Wip</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']"
      [queryParams]="{lead_status: lead_status}"
      *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager')">Lead</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']"
      [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer' && lead_details">Lead </span>
    <span *ngIf="lead_details" class="capitalize" style="vertical-align: -webkit-baseline-middle;"><i
        class="rightArrow fa fa-angle-right"></i> {{lead_details.lead_status | replaceChar}}</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;"
      *ngIf="lead_details && lead_details.user_reference">{{lead_details.user_reference.name}} -
      {{lead_details.project_details.name}}</span>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="row px-4 full_width">
  <app-shared-top-menu  class="apply_background" [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status'
    [boq_tab]='"active"'></app-shared-top-menu>
  <div class="col-12">
    <div class="row mb-5">
      <div class="col-md-12 bg-white pb-3">
        <app-sms-call></app-sms-call>

        <!-- RIYA CODE FROM BOQ STARTS -->
        <div class="row mt-4 d-flex justify-content-end"  >
          <div>
            <button type="button" class="btn btn-pink pull-right" style="font-size: 15px; cursor: pointer; width: 218px;" data-toggle="modal" (click)="importboqmodalopen()"
              data-target="#importBOQModal">Import BOQ through PRESET</button>
          </div>
          <div class="ml-3">
            <button type="button" class="btn btn-pink bt-boq mr-3" data-toggle="modal"
              data-target="#createquotationModal" *ngIf="selectedQuotationStatus != '10_50_percent'">Create BOQ</button>

          </div>
        </div>

        <ul class="nav nav-tabs tabs-chng mt-4" id="myTab" role="tablist">
          <li class="nav-item nav-items"  style="width: 120px;" >
            <a class="nav-link addCursor text-center" (click)="getQuotationListByStatus('pre_10_percent')"
              [ngClass]="{'active': selectedQuotationStatus == 'pre_10_percent'}">10% BOQs</a>
          </li>
          <li class="nav-item nav-items" style="width: 135px;" >
            <a class="nav-link addCursor text-center" (click)="getQuotationListByStatus('10_50_percent')"
              [ngClass]="{'active': selectedQuotationStatus == '10_50_percent'}">10-50% BOQs</a>
          </li>
          <li class="nav-item nav-items">
            <a class="nav-link active addCursor text-center mr-3" (click)="getQuotationListByStatus('all')"
              [ngClass]="{'active': selectedQuotationStatus == 'all'}">ALL</a>
          </li>
          <li class="nav-item nav-items" style="width: 100px;">
            <a class="nav-link addCursor text-center mr-3" (click)="getQuotationListByStatus('draft')"
              [ngClass]="{'active': selectedQuotationStatus == 'draft'}">DRAFT</a>
          </li>
          <li class="nav-item nav-items">
            <a class="nav-link addCursor text-center mr-3" (click)="getQuotationListByStatus('pending')"
              [ngClass]="{'active': selectedQuotationStatus == 'pending'}">PENDING</a>
          </li>
          <li class="nav-item nav-items">
            <a class="nav-link addCursor text-center mr-3" (click)="getQuotationListByStatus('shared')"
              [ngClass]="{'active': selectedQuotationStatus == 'shared'}">SHARED</a>
          </li>
          <li class="nav-item nav-items" style="width: 80px;">
            <a class="nav-link addCursor text-center mr-3" (click)="getQuotationListByStatus('paid')"
              [ngClass]="{'active': selectedQuotationStatus == 'paid'}">PAID</a>
          </li>
         
          <li class="nav-item nav-items">
            <a class="nav-link addCursor text-center" (click)="getQuotationListByStatus('expired')"
              [ngClass]="{'active': selectedQuotationStatus == 'expired'}">EXPIRED</a>
          </li>
          <!-- <li class="nav-item nav-items">
            <a class="nav-link addCursor text-center" (click)="getQuotationListByStatus('onhold')"
              [ngClass]="{'active': selectedQuotationStatus == 'onhold'}">ONHOLD</a>
          </li> -->
          <li class="nav-item nav-items">
            <a class="nav-link addCursor text-center" (click)="getQuotationListByStatus('cancelled')"
              [ngClass]="{'active': selectedQuotationStatus == 'cancelled'}">CANCELLED</a>
          </li>


        </ul>
        <div class="container-fluid container-set lappyView">
          <div class="row">
            <div class="col-md-12" *ngIf="quotations && quotations.length>0">
              <div class="tableDiv">
                <div class="table-responsive">
                  <table class="table " style="display: block;">
                    <thead class="thead-dark">
                      <tr>
                       
                        <th scope="col" (click)="sort('updated_at')">REF NO &<br /> LAST EDITED ON <i class="fa ml-2"
                            [ngClass]="{'fa-sort': column != 'updated_at','fa-sort-asc': (column == 'updated_at' && !isDesc), 'fa-sort-desc': (column == 'updated_at' && isDesc) }"
                            aria-hidden="true"> </i></th>
                        <!-- <th scope="col" (click)="sort('expiration_date')">PRICE EXPIRY  <i class="fa ml-2" [ngClass]="{'fa-sort': column != 'expiration_date','fa-sort-asc': (column == 'expiration_date' && !isDesc), 'fa-sort-desc': (column == 'expiration_date' && isDesc) }" aria-hidden="true"> </i></th> -->
                        <th (click)="sort('status')" style=" text-align:center; width: 8rem;">STATUS <i class="fa ml-2"
                            [ngClass]="{'fa-sort': column != 'status','fa-sort-asc': (column == 'status' && !isDesc), 'fa-sort-desc': (column == 'status' && isDesc) }"
                            aria-hidden="true"> </i></th>
                        <th>NET AMOUNT </th>
                        <th>DISCOUNT %</th>
                        <th>PROMO VALUE</th>
                        <th scope="col">PRICE MATCH <br/>Status / Discount</th>
                        <th scope="col">PM FEE</th>
                        <th scope="col"  (click)="sort('total_amount')">TOTAL AMOUNT <i class="fa ml-2"
                            [ngClass]="{'fa-sort': column != 'total_amount','fa-sort-asc': (column == 'total_amount' && !isDesc), 'fa-sort-desc': (column == 'total_amount' && isDesc) }"
                            aria-hidden="true"> </i></th>
                        <th>PARENT BOQ</th>
                        <th>PRESET ID &<br /> PRESET NUMBER</th>
                        <th class="lastTh"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let boq of quotations | slice : startPage:paginationLimit | sortDatewise: {property: column, direction: direction}; let i = index"
                        [attr.data-index]="i" class="box-list">
                        
                        <td class="minWidthTd">
                          <!-- <a class="a_hrefLink" [routerLink]="['/project/'+pid+'/boq/'+boq.id]" routerLinkActive='active' *ngIf="boq.modular==false">{{ boq.reference_number }}</a> -->
                          <span  *ngIf="boq.boq_status =='cancelled'"> <span  class="onhold">Cancelled </span><a style="margin-left: 3px; font-size: 14px;cursor: pointer;" data-toggle="modal" data-target="#exampleModalLongremark" (click)="getRemarkforcancell(boq)"><i data-toggle="tooltip" title="Remark Info" data-placement="top" class="fa fa-info-circle" aria-hidden="true"></i></a> </span><br>
                          <a class="a_hrefLink"
                            [routerLink]="['/lead/'+lead_details.id+'/project/'+pid+'/boq_modular/'+boq.id]"
                            routerLinkActive='active'>{{ boq.reference_number }}</a>
                          <span class="text-dark font-weight-bold mt-2" style="font-size: 12px;">({{boq.stage}})</span>
                          <span><button title="Upadted Remark" class="btn-change pop" data-toggle="modal"
                              data-target="#statusModal1" (click)="openBoqRemarkModal(boq.id,boq.remark)"
                              data-trigger="hover" [attr.data-content]="boq.remark" (mouseenter)="openpopup($event)"><i
                                class="fa fa-plus-circle" aria-hidden="true"></i></button></span><br>
                                {{boq.updated_at | date:"dd MMMM, y @ h:mma"}}
                        </td>
                  
                        <!-- <td>{{boq.expiration_date | date:'dd MMMM, y @ h:mma'}}</td> -->
                        <td class="capitalize text-center">
                          <span *ngIf="boq.status!='draft' && boq.status!='pending' ">{{boq.status}}</span>
                          <select class="form-control" (change)="changeQuotationStatus($event.target.value,boq.id)"
                            *ngIf="boq.status=='draft' || boq.status=='pending' ">
                            <option value="draft" [selected]="boq.status=='draft'">Draft</option>
                            <option value="pending" [selected]="boq.status=='pending'">Pending</option>
                            <!-- <option value="shared" [selected]="boq.status=='shared'">Shared</option>
                              <option value="paid" [selected]="boq.status=='paid'">Paid</option>
                              <option value="expired" [selected]="boq.status=='expired'">Expired</option> -->
                          </select>
                        </td>

                        <td class="minWidthTd">{{boq.net_amount | currency :'INR':'symbol'}}</td>
                        <td class="">{{boq.discount_value || 0}}</td>
                        <td class="minWidthTd text-center" *ngIf="!boq.promo_value_applied">
                          <!-- <i class="fa fa-inr mr-1"></i> -->
                           - </td>
                        <td class="minWidthTd text-center" *ngIf="boq.promo_value_applied">
                          <!-- <i class="fa fa-inr mr-1"></i> -->
                           - ({{boq.promo_value_applied}}) </td>
                        <td class="minWidthTd text-center" style="width: 8rem;"><span class="capitalize" *ngIf="boq.price_match_status != 'yet_to_apply'">{{boq.price_match_status}} &nbsp;/</span> {{boq.price_match_discount | number:'.1-2'}}%</td>
                        <td class="minWidthTd text-center"><i class="fa fa-inr" style="margin-right: 0.15rem;"></i>{{boq.pm_fee || 0}}</td>
                        
                        <td class="minWidthTd" >{{ boq.total_amount | currency :'INR':'symbol'}}</td>
                        <td class=" text-center" style="min-width: 140px;" >{{ boq.parent_quotation_reference_no }}</td>
                        
                        <td class="minWidthTd text-center" *ngIf="!boq.portfolio_details">- </td>
                        <td class=" text-center " *ngIf="boq.portfolio_details"><a (click)="btnClick2(boq.portfolio_details.id); getDetailsimportPortfolio(boq.portfolio_details.id)"  target="_blank"  style="color:#007bff;cursor:pointer">{{boq.portfolio_details.id}}</a> & {{boq.portfolio_details.preset_number}}</td>    
                        <td class="text-center" style="width:40px !important;display:inline-block;margin-top: 20px;">
                          <i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#"
                            role="button" aria-haspopup="true" aria-expanded="false"></i>
                          <div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                            <a class="dropdown-item addCursor" (click)="deleteBoq(boq.id)"
                              *ngIf="(boq.status=='draft' || boq.status=='pending') && boq.parent_quotation_id==null">Delete</a>
                            <a class="dropdown-item addCursor" (click)="downloadPdfCheck(boq.id,'Designer')"
                              data-target="#boqCheckModal" data-toggle="modal">Download Designer Boq PDF</a>

                            <a class="dropdown-item addCursor" (click)="downloadCustomerPdf(boq.id,'Customer')"
                              data-target="#boqCheckModal" data-toggle="modal">Download Customer Boq PDF</a>
                            <a class="dropdown-item addCursor" data-toggle="modal" data-target=".InvoiceModal"
                              (click)="downloadCheatSheet(boq.id)">Download Cheat Sheet</a>
                              <!-- <a class="dropdown-item addCursor" data-toggle="modal" data-target="#markashold"
                              (click)="openBoqRemarkModalOnhold(boq.id,boq.remark)">Mark as Onhold</a> -->
                             <a  *ngIf="boq.boq_status =='cancelled'" class="dropdown-item addCursor" data-toggle="modal" data-target="#markasactive"
                             (click)="openBoqRemarkModalInactive(boq.id,boq.remark)">Mark as Active</a>
                              <a *ngIf="boq.boq_status =='active'" class="dropdown-item addCursor" data-toggle="modal" data-target="#markasinactive"
                              (click)="openBoqRemarkModalActive(boq.id,boq.remark)">Mark as Cancelled</a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button type="button" class="btn-lg bt-boqs" (click)="showMore()"
                    *ngIf="(quotations.length - paginationLimit)>0">Show More
                    BOQs({{ quotations.length - paginationLimit}})</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mobView">
          <div class="col-md-12 mt-3" *ngIf="quotations && quotations.length>0">
            <div
              *ngFor="let boq of quotations | slice : startPage:paginationLimit | sortDatewise: {property: column, direction: direction}; let i = index"
              [attr.data-index]="i">
              <div class="card card-body mobCard mb-2">
                <a data-toggle="collapse" href="#tableDiv{{i}}">
                  <i class="fa fa-angle-right"></i>
                </a>
                <h4 class="ss-link cursor-pointer" [routerLink]="['/project/'+pid+'/boq/'+boq.id]"
                  routerLinkActive='active'>REF NO. : {{ boq.reference_number }}</h4>
                <div class="row">
                  <p class="col-7 mb-0">Status: {{ boq.status}}</p>
                  <h6 class="col-5 mb-0">
                    <i class="fa fa-inr mr-1"></i>{{ boq.total_amount}}</h6>
                </div>
              </div>
              <div class="collapse" id="tableDiv{{i}}">
                <div class="card card-body py-0 mb-3 border-0">
                  <div class="row">
                    <div class="col-12 py-3 borderRight">
                      <p class="tableInner">LAST EDITED</p>
                      <p>{{boq.updated_at | date:"dd MMMM, y @ h:mma"}}</p>
                    </div>
                    <div class="col-12 py-3 borderRight">
                      <p class="tableInner">PRICE EXPIRE</p>
                      <p>{{boq.expiration_date | date:'dd MMMM, y @ h:mma'}}</p>
                    </div>
                    <div class="col-6 callBtn">
                      <div>
                        <a class="addCursor" (click)="deleteBoq(boq.id)">Delete</a>
                      </div>
                    </div>
                    <div class="col-6 callBtn">
                      <div>
                        <a class="addCursor" (click)="downloadboq(boq.id)">Download Boq</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 not-found " *ngIf="quotations && quotations.length==0 ">
          <div class="boq-img">
            <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
          </div>
          <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
        </div>
        <!-- RIYA CODE FROM BOQ ENDS -->
      </div>
    </div>
  </div>
</div>

<!-- Modal create quotation -->
<div id="createquotationModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content modal-change">
      <div class="modal-header">
        <h6 class="modal-title textColor" style="font-size:18px">Create New BOQ</h6>
      </div>
      <div class="modal-body">
        <form [formGroup]="selectBoqTypeForm1">
          <div>
            <p class="textColor my-3">
              <input type="radio" formControlName="boqType" value="create_boq" id="text0" class="mr-2"
                (change)="checkBoqType('create_boq')">
              <label for="text0" class="texts">Create a new Boq</label>
            </p>
            <p *ngIf="this.canCreateFinalBOQ" class="textColor my-3">
              <input type="radio" formControlName="boqType" value="create_final_boq" id="text_final" class="mr-2" (change)="checkBoqType('create_final_boq')">
              <label for="text_final" class="texts" >Create a Final Boq</label>
            </p>

            <!-- Service or non-service rdio btn -->
            <div class="firstDiv textColor" *ngIf = "showTypesofBoq">
              <input type="radio" formControlName="serviceType" value="service" id="sType1" class="mr-2" (change) = "serviceTypeBoq('service')" />
              <label for="sType1" class="texts sectionType-class1">Service</label>

              <input type="radio" formControlName="serviceType" value="non_service" id="sType2" class="mr-2" (change) = "serviceTypeBoq('non_service')" />
              <label for="sType2" class="texts ml-2 sectionType-class1">Non-Service</label>
            </div>
            <!-- ----------------------------------------- -->

            <form [formGroup]="selectSectionTypeForm">
              <div class="sectionDiv">
                <label>
                  <span class="sectionType-class1 activeselectColor">Choose Section:</span>
                </label>
                <br />

                <input style="font-size:12px" type="checkbox" name="sections" value="modular_wardrobe"
                  (change)="onCheckChange($event)" class="sectionType-class"> <span class="activeselectColor sectionType-class">Modular
                  Wardrobe</span><br>
                <input type="checkbox" name="sections" value="modular_kitchen" (change)="onCheckChange($event)"
                  class="sectionType-class"> <span class="activeselectColor sectionType-class">Modular
                  Kitchen</span><br>
                <input type="checkbox" name="sections" value="loose_furniture" (change)="onCheckChange($event)"
                  class="sectionType-class"><span class="activeselectColor sectionType-class"> Loose
                  Furniture</span><br>
                <input type="checkbox" name="sections" value="custom_furniture" (change)="onCheckChange($event)"
                  class="sectionType-class"><span class="activeselectColor sectionType-class"> Custom
                  Furniture</span><br>
              </div>
            </form>
          </div>
          <hr class="custom-hr hrTag" />
          <!-- <div>
              <p class="textColor my-3">
                <input type="radio" formControlName="boqType" value="create_boq_lf" id="text1" class="mr-2" (change)="checkBoqType('create_boq_lf')">
                <label for="text1" class="texts" >Create a new Boq for Loose Furniture</label>
              </p>
            </div>
            <hr class="custom-hr hrTag" /> -->
          <div>
            <p class="textColor my-3">
              <input type="radio" formControlName="boqType" value="import_boq" id="text2" class="mr-2"
                (change)="checkBoqType('import_boq')">
              <label for="text2">Import Existing BOQ</label>
            </p>
            <form [formGroup]="importBoqForm">
              <div class="sorting">
                <div class="sort right">
                  <label>
                    <span class="importType-class1">Select Project:</span></label>
                  <select style="-webkit-appearance: none;-moz-appearance: none;     height: 32px;
    font-size: 11px;
    width: 135px;"
                    class="importType-class form-control ml-3 capitalize" formControlName="project"
                    (change)="importQuotationValue($event.target.value)">
                    <option value="">Select Project</option>
                    <option *ngFor="let project of importedProjectList" value="{{project.id}}">
                      {{ project.attributes.lead_name}}-{{project.attributes.name}}</option>
                  </select>
                  <span class="pointer"><i class="fa fa-angle-down"></i></span>

                </div>
              </div>
              <div class="sorting">
                <div class="sort right"><label>
                    <span class="importType-class1">Select BOQ:</span></label>
                  <select class="importType-class form-control " (change)="getBoqType($event.target.value)"
                    formControlName="boq" style="margin-left: 31px;-webkit-appearance: none;-moz-appearance: none; height: 32px;
    font-size: 11px;
    width: 135px;">
                    <option value="">Select BOQ</option>
                    <ng-container *ngFor="let boq of importquotations">
                      <option value="{{boq.id}}">{{boq.attributes.reference_number}}</option>
                    </ng-container>
                  </select>

                  <span class="pointer"><i class="fa fa-angle-down"></i></span>

                </div>
              </div>

              <div class="sorting">
                <div class="sort right"><label>
                    <span class="importType-class1">BOQ Type:</span></label>
                  <select class="importType-class form-control "
                    formControlName="boqType" style="margin-left: 41px;-webkit-appearance: none;-moz-appearance: none; height: 32px;
    font-size: 11px;
    width: 135px;">
                    <option value="">Select BOQ Type</option>
                    <ng-container *ngIf = "import_boq_type == 'hybrid'">
                      <option value="service">Service</option>
                      <option value="non_service">Non-Service</option>
                    </ng-container>
                    <option value="non_service" *ngIf = "import_boq_type == 'non_service'">Non-Service</option>
                    <option value="service" *ngIf = "import_boq_type == 'service'">Service</option>
                  </select>

                  <span class="pointer"><i class="fa fa-angle-down"></i></span>

                </div>
              </div>

              <div class="sorting">
                <div class="sort right"><label>
                  <span class="importType-class1">Select Stage:</span></label>
                    <select class="importType-class form-control " (change)="selectType($event.target.value)" formControlName="stage" style="margin-left: 24px;-webkit-appearance: none;-moz-appearance: none;height: 32px;
    font-size: 11px;
    width: 135px;">
                      <option value="">Select Stage</option>
                      <option value="initial">Initial</option>
                      <option *ngIf="this.canCreateFinalBOQ" value="final">Final</option>
                    </select>
                    <span class="pointer"><i class="fa fa-angle-down"></i></span>
                </div>
              </div>
            </form>
          </div>
        </form>
      </div>
      <div class="modal-footer ">
        <button class="btn btn-primary interalBtnColor addCursor modalBtn" (click)="submitForm(selectBoqTypeForm1.value,selectSectionTypeForm.value,importBoqForm.value)" [disabled]="(selectBoqTypeForm1.value.boqType=='import_boq' && (importBoqForm.value.project=='' || importBoqForm.value.project==null ||  importBoqForm.value.project==undefined || importBoqForm.value.boq=='' || importBoqForm.value.boq==undefined || importBoqForm.value.boq== null || importBoqForm.value.stage=='' || importBoqForm.value.stage==undefined || importBoqForm.value.stage== null || importBoqForm.value.boqType=='' || importBoqForm.value.boqType==undefined || importBoqForm.value.boqType== null)) || ((selectBoqTypeForm1.value.boqType=='create_boq' || selectBoqTypeForm1.value.boqType=='create_final_boq') && !selectSectionTypeForm.valid)">Create</button>
        <button type="button" class=" btn btn-primary btnCancel btnchng" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>


<!--Import BOQ Modal-->
<div id="importBOQModal" class="modal fade" role="dialog" aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="modal-dialog my-2 mx-2">

    <!-- Modal content-->
    <div class="modal-content" *ngIf="browse_inclusion_activated">
      <div class="modal-header d-flex justify-content-end">
        <!-- <h6 class="modal-title textColor" style="font-size:18px">Browse Preset</h6> -->
        <button aria-label="Close" class="close-change cursor-pointer pull-right" data-dismiss="modal" type="button"
              (click)="closeModalpreset()" style="outline: none;">
              <img src="../../../assets/img/cross-out.svg" style="width:13px;">
            </button>
      </div>
      <div class="modal-body">
        <div class="container" style="background-color: #ffffff;">
          <!-- <div class="container-fluid">
            <div class="row justify-content-center pt-4">
              <h2>Browse Preset</h2>
              </div>
          </div> -->
          <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-md-10">
              <div class="row border my-4 align-items-center brdradius">
            <div class="col-md-3 borderright brdrbtm">
              <div class="form-group">
                <label class="ml-3 mb-0 fs14">Select Space Type</label>
                <select
                  class="form-controlpreset border-0 text-capitalize"
                  (change)="spaceFilter($event)"
                  style="color: #000000; font-size: 17px; outline: none;"
                  [(ngModel)]="space_drop"
                >
                <option value="" selected disabled>All</option>
                        <ng-container *ngFor="let item of space_name">
                          <option [selected]="item == this.space_name" >{{ transform(item) }}</option>
                        </ng-container>
                </select>
              </div>
            </div>
            <div class="col-md-3 borderright brdrbtm">
              <div class="form-group">
                <label class="ml-3 mb-0 fs14">Select Your Lifestage </label>
                <select
                  class="form-controlpreset border-0 text-capitalize"
                  (change)="lifeStageFilter($event)"
                   style="color: #000000; font-size: 17px; outline: none;"
                   [(ngModel)]="lifestage_drop"
                >
                  <option value="" selected disabled>Select</option>
                  <ng-container *ngFor="let item of lifestage">
                    <option *ngIf="item !== ''">{{ transform(item) }}</option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-md-3 brdrbtm borderright">
              <div class="form-group">
                <label class="ml-3 mb-0 fs14">Select Theme</label>
                <select
                  class="form-controlpreset border-0 text-capitalize"
                  (change)="themeFilter($event)"
                   style="color: #000000; font-size: 16px; outline: none;"
                   [(ngModel)]="theme_drop"
                >
                  <option value="" selected disabled>Select</option>
                  <ng-container *ngFor="let item of theme">
                    <option *ngIf="item !== ''">{{ transform(item) }}</option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="ml-3 mb-0 fs14">Select Price Range</label>
                <select
                  class="form-controlpreset border-0 text-capitalize"
                  (change)="priceFilter($event)"
                   style="color: #000000; font-size: 16px; outline: none;"
                   [(ngModel)]="price_drop"
                >
                  <option value="" selected disabled>Select</option>
                  <ng-container *ngFor="let item of pricerange">
                    <option *ngIf="item !== ''">{{ item.name }}</option>
                  </ng-container>
                </select>
              </div>
            </div>
            </div>
          </div>
          </div>
          </div>
          <div class="container-fluid mb-5">
            <div class="row mt-4 justify-content-center">
              <div class="col-md-10 col-lg-10 col-sm-12">
                <div class="row">
                  <ng-container
                    *ngFor="
                      let portfolio of list?.portfolios
                        | paginate
                          : {
                              itemsPerPage: 9,
                              currentPage: current_page,
                              totalItems: total_page
                            };
                      let i = index
                    "
                  >
                    <div class="col-md-4 col-lg-4 col-sm-12 mb-4">
                      <a (click)="btnClick(portfolio.id); getDetailsimportPortfolio(portfolio.id)" class="img-point" target="_blank">
                      <img data-src="{{portfolio.attachment_file}}" alt="image not" class="imageone img-fluid w-100"
                      onerror="src='../../../assets/img/default-apartment.png'" />
                        </a>
                        <div [ngClass]="{'no-arrow': portfolio.lifestage === ''}" class="d-flex justify-content-center titlediv">
                          <span  class="titleTriangle2 text-capitalize align-items-center d-flex">
                            <img *ngIf="portfolio.lifestage ==='young_vibes'" src="../../../assets/img/YOUNG VIBES.svg" />
                      <img *ngIf="portfolio.lifestage ==='love_vibes'" src="../../../assets/img/Page 2.svg" />
                      <img src="../../../assets/images/Page 3.svg" *ngIf="portfolio.lifestage==='Working Couple'"/>
                      <img src="../../../assets/img/Page 4.svg" *ngIf="portfolio.lifestage==='Old Age'"/>
                      <img src="../../../assets/img/Page 2.svg" *ngIf="portfolio.lifestage==='Bachelor'"/>
                      <img src="../../../assets/img/YOUNG VIBES.svg" *ngIf="portfolio.lifestage==='Large Families'"/>
                      <img src="../../../assets/img/Page 4.svg" *ngIf="portfolio.lifestage==='lively_vibes'"/>
                      <img src="../../../assets/img/Page 2.svg" *ngIf="portfolio.lifestage==='happy_vibes'"/>
                      <img src="../../../assets/img/Page 3.svg" *ngIf="portfolio.lifestage==='baby_vibes'">
                      <img src="" *ngIf="portfolio.lifestage===''"/>
                            <span class="ml-2">{{
                              transform(portfolio.lifestage)
                                
                            }}</span>
                            <div [ngClass]="{'no-arrow':portfolio.lifestage === ''}" class="arrow-down1"></div>
                          </span>
                        </div>
                        <!-- <div class="d-flex"> -->
                          <a (click)="btnClick(portfolio.id)" class="img-point" target="_blank">
                      <div class="enter">{{portfolio.space}}&nbsp;-&nbsp;<span>{{portfolio.id}}</span></div></a>
                      <div class="unit">
                        Preset Number: {{ portfolio.preset_number }}
                      </div>
          
                        <!-- </div> -->
                      <!-- <div class="d-flex"> -->
                      <div *ngIf="!portfolio.boq_value  " class="unit">
                        Price: &#8377; {{ portfolio.price | number: '.1-2'}}
                      </div>
                      <div *ngIf="portfolio.boq_value " class="unit">
                        Boq Value: &#8377; {{ portfolio.boq_value | number: '.1-2'}}
                      </div>
                      
                      <!-- </div> -->
          
                    </div>
                    
                  </ng-container>
                  <div
                    class="text-center w-100 mt-5 mb-3 cusPagiWeb"
                    *ngIf="list && list.portfolios.length > 0"
                  >

                    <pagination-controls
                      (pageChange)="getpageNumber($event)"
                      (pageBoundsCorrection)="getpageNumber($event)"
                      previousLabel="PREV"
                      nextLabel="NEXT"
                    >
                    </pagination-controls>
                  </div>
                </div>
          
                <div
                  style="text-align: center; font-size: 16px; color: #8d0528"
                  *ngIf="list && list.portfolios.length === 0"
                >
                  No Data Available
                </div>
              </div>
            </div>
          </div>
          </div>
      </div>
    </div>
    <div class="modal-content" *ngIf="preset_inclusion_activated">
      <div class="modal-header d-flex justify-content-end">
        <!-- <h6 class="modal-title textColor" style="font-size:18px">Browse Preset</h6> -->
        <button aria-label="Close" class="close-change cursor-pointer pull-right" data-dismiss="modal" type="button"
              (click)="closePresetModal()" style="outline: none;">
              <img src="../../../assets/img/cross-out.svg" style="width:13px;">
            </button>
      </div>
<div class="container" style="background-color: #ffffff; padding-bottom: 6rem;">
	<div class="rk-ui-notification" *ngIf="successalert">
		<span id="notificationMessageText">{{successMessage}}</span>
		<a class="close rk-linknotification" (click)="successalert=false">×</a>
	</div>
	<div class="rk-ui-notification err" *ngIf="erroralert">
		<span id="notificationMessageText">{{errorMessage}}</span>
		<a class="close rk-linknotification" (click)="erroralert=false">×</a>
	</div>
<div class="container-fluid">
<div class="row pt-4">
	<!-- <button (click)="gobrowse()" class="back-btn">Back</button> -->
</div>
  <div class="row justify-content-center pt-4">
    <h2>{{fetchData.portfolio.space}} - {{fetchData.portfolio.id}} ({{fetchData.portfolio.preset_number}})</h2>
    </div>
</div>
<div class="container-fluid backcolor">
	<div class="row justify-content-center">
		<div class="col-md-10">
		<div class="row">	
		<div class="col-sm-3 col-md-6 col-lg-4">
			<img src={{fetchData?.portfolio.attachment_file}} onerror="src='../../../assets/img/default-apartment.png'" alt="" class="image w-100">

		</div>
		<div class="col-sm-6 col-md-6 col-lg-8 mt-3">
		<p>
				{{transform(fetchData.portfolio.description)}}
    </p>	
   
		<p class="text-capitalize">
			<span class="font-weight-bold">
				Life Stage: 
			</span>
			<span class="">
				{{transform(fetchData.portfolio.lifestage)}}
			</span>
		</p>

		<p class="text-capitalize">
				<span class="font-weight-bold">
					Theme: 
				</span>
				<span>
					{{transform(fetchData.portfolio.theme)}}
				</span>
			</p>

		<p class="text-capitalize">
      <span *ngIf="!fetchData.portfolio.boq_value">
				<span  class="font-weight-bold">
					Budget: 
				</span>
				<span >
					Price:</span>
				<span  >{{fetchData.portfolio.price | currency: 'INR':true}}
				</span>
      </span>
      <span *ngIf="fetchData.portfolio.boq_value">
        <span  class="font-weight-bold">
					Budget: 
				</span>
				<span>
					Boq Value:</span>
				<span >{{fetchData.portfolio.boq_value | currency: 'INR':true}}
				</span>
      </span>
			</p>

      
      <p class="text-capitalize">
				<span class="font-weight-bold">
					Preset Number: 
				</span>
				<span>
					{{fetchData.portfolio.preset_number}}
				</span>
			</p>
		</div>
		</div>
		</div>
	</div>
</div>
<div class="container-fluid">
	<div class="row justify-content-center">
		<div class="col-md-10 mt50px">
		  <div class="d-flex">
        <div class="titleTriangle"
      >INCLUSION OF THE DESIGN
  </div>
      <span class="arrow-down"></span>
    <img
      src="../assets/img/Fill-117.svg"
      class="smallLogoIcon zI1"
      alt="vwuy"
    />
      </div>
		</div>
	  </div>
</div>
<div class="container-fluid mt-4">
	<div class="row justify-content-center">
		<div class="col-md-10 col-sm-12">
			<div class="row">
				<div class="col-md-12">
          <div class="profile2">
					
            <!-- <img src={{fetchData.portfolio.attachment_file}} onerror="src='../../../assets/img/default-apartment.png'" class="w-100"> -->
            <div
            id="carouselExampleControls"
            class="carousel slide"
            data-ride="carousel"
            *ngIf="fetchData && fetchData.portfolio.contents.length != 0"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="{{ fetchData.portfolio.attachment_file }}"
                  onerror="src='../../../assets/images/default-apartment.png'"
                  class="w-100"
                />
              </div>
              <ng-container
                *ngFor="let images of fetchData.portfolio.contents"
              >
                <div class="carousel-item">
                  <img
                    class="d-block w-100"
                    [src]="images.attributes.document"
                    onerror="src='../../../assets/images/default-apartment.png'"
                    class="w-100"
                    alt="First slide"
                  />
                </div>
              </ng-container>
            </div>
            <a
              class="carousel-control-prev"
              href="#carouselExampleControls"
              role="button"
              data-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="carousel-control-next"
              href="#carouselExampleControls"
              role="button"
              data-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Next</span>
            </a>
          </div>	
          <div
          *ngIf="fetchData && fetchData.portfolio.contents.length == 0"
        >
          <img
            src="{{ fetchData?.portfolio.attachment_file }}"
            onerror="src='../../../assets/img/default-apartment.png'"
            class="w-100"
          />
        </div>
    </div>
					</div>
					</div>
		</div>
		
	</div>
</div>

<!-- <div class="container-fluid mt-3">
	<div class="row justify-content-center">
		<div class="col-md-10 col-10">
				<div class="row">
				<ng-container *ngFor = "let item of fetchData.portfolio.space_items">
						<div class="col-12 col-md-3 rectangular1">
								<div class="row">
									<div class="col-8">
										<div class="oven text-capitalize"> {{item.item_name}}</div>
										<div style="font-size: 13px;">{{item.description}}
										<p class="include">Include Me:
											<label class="switch">
												<input type="checkbox" value="{{item.id}}" (change) = "getItems($event,item.id,item)" checked>
												<span class="slider round"></span>
											</label>
										</p>
										
									</div>
									</div>
									<div class="col-4">
										<img class="img-fluid" src={{item.image}} onerror="src='../../../assets/img/default-apartment.png'">
									</div>
								</div>
							</div>
				</ng-container>
				</div>
		</div>
	</div>
</div> -->
<!-- <div class="container-fluid mt-3">
	<div class="row justify-content-center">
		<div class="col-md-10 col-10">
			<<div class="pl-3 pr-3 pl-lg-0 pr-lg-0"> -->
				<!-- <div class="row">
				<ng-container *ngFor = "let item of fetchData?.portfolio?.space_items"> -->
					<!-- <div class="row"> -->
						<!-- <div class="col-12 col-md-3 rectangular1">
								<div class="row">
									<div class="col-8">
										<div class="oven text-capitalize"> {{item.item_name}}</div>
										<div style="font-size: 13px;">{{item.description}}
										<p class="include">Include Me:
											<label class="switch">
												<input type="checkbox" value="{{item.id}}" checked>
												<span class="slider round"></span>
											</label>
										</p>
										
									</div>
									</div>
									<div class="col-4">
										<img class="img-fluid" src={{item.image}} onerror="src='../../../assets/img/default-apartment.png'">
									</div>
								</div>
							</div>
				</ng-container>
				</div>
		</div>
	</div>
</div> --> 

<div class="container-fluid mt-3">
  <div class="row justify-content-center">
    <div class="col-md-10 col-12">
      <div class="row justify-content-between">
  <div *ngIf="!fetchData.portfolio.boq_value" class="emi-dta-styl">
    <span class="emi-style">
      Price:</span>
      <span class="data-style"> {{fetchData.portfolio.price | currency: 'INR':true}}
    </span>
  </div>
</div>
<div *ngIf="fetchData.portfolio.boq_number" class="row justify-content-between">
  <div class="emi-dta-styl">
    <span class="emi-style">
      Boq Number:</span>
    <a style="cursor: pointer;" (click)="downloadCustomerBoqPdfPreset()"><span class="data-style"> {{fetchData.portfolio.boq_number}}
    </span></a>
  </div>
  </div>
<div *ngIf="fetchData.portfolio.boq_value" class="row justify-content-between">
  <div  class="emi-dta-styl">
    <span class="emi-style">
      Boq Value:</span>
      <span class="data-style"> {{fetchData.portfolio.boq_value}}
    </span>
  </div>
</div>

    </div>
  </div>
  </div>


  <form [formGroup]="importBoqPresetForm">
    <div class="container-fluid mt-5">
      <div class="row justify-content-center">
        <div class="col-md-10 col-12">
          <div class="row">
            <div class="col-5 d-flex">
              <!-- <div class="sorting"> -->
                <label>
                <span *ngIf="boqNumber" class="">BOQ Type:</span></label>
           <select *ngIf="boqNumber" class=" form-control" style="margin-left: 31px; -webkit-appearance: none;-moz-appearance: none; width: 15rem;" formControlName="boqTypepreset">
              <option selected value="" >Select BOQ Type</option>
              <ng-container *ngIf="boq_type11 == 'hybrid'">
                <option value="service">Service</option>
                <option value="non_service">Non-Service</option>
              </ng-container>
              <option value="non_service" *ngIf = "boq_type11 == 'non_service'">Non-Service</option>
              <option value="service" *ngIf = "boq_type11 == 'service'">Service</option>
            </select>
            <!-- </div> -->
            <!-- </div> -->
            </div>
            <div class="col-5 d-flex">
              <!-- <div class="sorting"> -->
                <label>
                <span *ngIf="boqNumber" class="">Stage Type:</span></label>
            <select *ngIf="boqNumber" class="form-control" formControlName="stagepreset" style="-webkit-appearance: none;-moz-appearance: none; margin-left: 31px; width: 15rem;">
              <option selected value="">Select Stage</option>
              <option value="initial">Initial</option>
              <option *ngIf="create_final_boq == true" value="final">Final</option>
            </select>
          <!-- </div> -->
          <!-- </div> -->
            </div>
            </div>
        </div>
      </div>
    </div>
          </form>
  
  <button *ngIf="boqNumber"  class="btn btn-primary interalBtnColor addCursor modalBtn" [disabled]="boqNumber == null || importBoqPresetForm.invalid" (click)="submitPresetForm(importBoqPresetForm.value,fetchData.portfolio.id)" style="margin-top: -2.3rem;">Import</button>
	<!-- </div> -->

  </div>
  </div>
  </div>
</div>


<div class="loading d-block justify-content-center" *ngIf="loader">
  <div class="spinner-border" style="color: #8d0528;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<!--Import Browse Preset Modal-->
<!-- <div id="importBOQInclusionModal" class="modal fade" role="dialog" aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: scroll;">
  <div class="modal-dialog my-2 mx-2"> -->
    
  <!-- </div>
</div> -->


<!-- Status Remark modal -->
<div class="modal fade" id="statusModal1" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>BOQ REMARK:</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img class="close" data-dismiss="modal"
            src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group row">
          <label for="example-text-input" class="col-2 col-form-label">Remarks </label>
          <div class="col-10">
            <textarea rows="1" name="boq_remarks" id="boq_remarks" class="form-control"></textarea>
            <!-- <input type="da" name="followup-details" id="followup-details" class="form-control"> -->
          </div>
        </div>


      </div>
      <div class="modal-footer">
        <input type="button" id="followup-button" value="Update" class="btn btn-pink" (click)="onBoqRemarkSubmit()">
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="markashold" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>BOQ STATUS CHANGE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img class="close" data-dismiss="modal"
          src="../../../assets/img/cross-out.svg" style="width:13px;">
        </button>
      </div>
      <div class="modal-body">
        <label for="example-text-input" class=" col-form-label">Remarks/Reason for Onhold </label>
        <div class="form-group row">
         
          <div class="col-10">
            <textarea rows="2" name="boq_remarks" id="boq_remarksOnhold" class="form-control"></textarea>
            <!-- <input type="da" name="followup-details" id="followup-details" class="form-control"> -->
          </div>
        </div>


      </div>
      <div class="modal-footer">
        <input type="button" id="followup-button" value="Done" class="btn btn-pink" (click)="boqOnholdStatus()" >
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="markasinactive" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>BOQ STATUS CHANGE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img class="close" data-dismiss="modal"
          src="../../../assets/img/cross-out.svg" style="width:13px;">
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="sendremark" >
        <label for="example-text-input" class=" col-form-label">Remarks/Reason for Cancelled <span class="astric">*</span> </label>
        <div class="form-group row">
         
          <div class="col-10">
            <textarea rows="2" name="boq_remarks" id="boq_remarksInactive" class="form-control" formControlName="sendremarkto"></textarea>
            <!-- <input type="da" name="followup-details" id="followup-details" class="form-control"> -->
          </div>
        </div>
        </form>

      </div>
      <div class="modal-footer">
        <input type="button" id="followup-button" value="Done"  [disabled]="!sendremark.valid" class="btn btn-pink" (click)="boqInactiveStatus()" >
      </div>
      
    </div>
  </div>
</div>
<div class="modal fade" id="exampleModalLongremark" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>BOQ STATUS CHANGE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img class="close" data-dismiss="modal"
          src="../../../assets/img/cross-out.svg" style="width:13px;">
        </button>
      </div>
      <div class="modal-body">
        <label for="example-text-input" class=" col-form-label">Remarks/Reason for Cancelled </label>
        <div class="form-group row">
         
          <div class="col-10">
            <textarea rows="2" name="boq_remarks" id="boq_remarksInactive" class="form-control" [ngModel]="remarkinfo" readonly></textarea>
            <!-- <input type="da" name="followup-details" id="followup-details" class="form-control"> -->
          </div>
        </div>


      </div>
     
    </div>
  </div>
</div>
<div class="modal fade" id="markasactive" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 55rem;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">BOQ Status Change</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Do you want to Change Boq Status to Active 
      </div>

      <!-- Modal footer -->
      <div class="modal-footer border-0">
        <button type="button" class="btn searchBtnboq" (click)="boqActiveStatus()">Yes</button>
        <button type="button" class="btn searchBtnboq" data-dismiss="modal">No</button>
      </div>

    </div>
  </div>
</div>

<!-- Status modal end -->




<!-- Modal For Boq check pdf -->

<div class="modal fade" id="boqCheckModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header border">
        <h5 class="modal-title" id="exampleModalLabel" style="font-family: 'algerian';">CHOOSE BOQ PDF FORMAT</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearCheckBox()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row justify-content-center">

          <div class="col-md-8">
            <label class="mr-3">
              <input type="checkbox" value="boq" (change)="selectPdfFormat($event)" [(ngModel)]="isChecked1">
              BOQ
            </label>
            <label class="mr-3">
              <input type="checkbox" value="annexure" (change)="selectPdfFormat($event)" [(ngModel)]="isChecked2">
              ANNEXURE
            </label>
            <label>
              <input type="checkbox" value="summary" (change)="selectPdfFormat($event)" [(ngModel)]="isChecked3">
              SUMMARY
            </label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary cursor-pointer" data-dismiss="modal"
          (click)="clearCheckBox()">Close</button>
        <button *ngIf="this.Designertype && this.Designertype=='Designer'" type="button" class="btn btn-pink"
          (click)="downloadPdf()">Download Designer Boq Pdf</button>
        <button *ngIf="this.Customertype && this.Customertype=='Customer'" type="button" class="btn btn-pink"
          (click)="downloadCustomerBoqPdf()">Download Customer Boq Pdf</button>
      </div>
    </div>
  </div>
</div>



<!-- End here -->


<!-- Modal For Invoce Boq -->
<div class="modal fade InvoiceModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" id="modalInvoiceId">
      <button type="button" class="close custom-close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body" *ngIf="selected_boq_details">
        <div class="container-fluid px-4">
          <div class="row borders border-bottom-0 border-dark">
            <div class="col-md-8 border-right border-dark">
              <div class="logo">
                <img src="../../../assets/img/mainLogo.svg" width="100%">
              </div>

            </div>
            <div class="col-md-4">
              <p class="quoteFont">Quotation</p>
            </div>

          </div>
          <div class="row borders border-dark">
            <div class="col-md-8 border-right border-dark">
              <div class="address">
                AZB Services LLP
                B501/502, Everest House, Suren Road, Gundavali
                Andheri East, Mumbai - 400093

              </div>

            </div>
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-6 border border-top-0 border-dark">
                  Date
                </div>
                <div class="col-md-6 border border-top-0  border-dark">
                  {{selected_boq_details.generation_date}}
                </div>

              </div>
              <div class="row  ">
                <div class="col-md-6 border border-dark">
                  Lead ID
                </div>
                <div class="col-md-6 border border-dark">
                  {{selected_boq_details.lead_id}}
                </div>

              </div>
              <div class="row">
                <div class="col-md-6 border  border-bottom-0 border-dark">
                  BOQ Number
                </div>
                <div class="p-1 col-md-6 border border-bottom-0 border-dark">
                  {{selected_boq_details.reference_number}}
                </div>

              </div>
            </div>

          </div>

          <div class="row mt-3">
            <table class="table1 table-bordered table-css-chng">
              <thead>
              </thead>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{{selected_boq_details.lead_name}}</td>
                  <td>Designer Name</td>
                  <td>{{selected_boq_details.designer_name}}</td>
                </tr>
                <!-- <tr>
                        <td>Contact</td>
                        <td>{{selected_boq_details.lead_contact}}</td>
                        <td>Designer Contact</td>
                        <td>{{selected_boq_details.designer_contact}}</td>
                    </tr> -->
                <tr>
                  <td class="minTdWidth">Project Name and Address</td>
                  <td class="minTdWidth">
                    {{selected_boq_details.project_name}},
                    <br>
                    {{selected_boq_details.lead_location}}
                  </td>
                  <td>Designer Email ID</td>
                  <td>{{selected_boq_details.designer_email}}</td>
                </tr>

              </tbody>
            </table>

          </div>
          <div *ngFor="let space of selected_boq_details.all_spaces">
            <span class="spanChange">{{space}}</span>
            <div class="row mt-3">
              <table class="table1 table-bordered">
                <thead>
                  <th scope="col">Sr. No.</th>
                  <th scope="col">Product</th>
                  <th scope="col">Name</th>
                  <th scope="col">Description</th>
                  <th scope="col" style="width: 6.6%">BOQ Label</th>
                  <th scope="col">Rate</th>
                  <th scope="col">Qty.</th>
                  <th scope="col">Final Price</th>

                </thead>
                <tbody>
                  <tr class="rowChng"
                    *ngFor="let item of selected_boq_details.quotation_body.boq_hash[space];let i = index">
                    <td>{{ i+1}}</td>
                    <td>{{item.product}}</td>
                    <td>{{replceUnderScore(item.name)}}</td>
                    <td>
                      {{item.description}}
                    </td>
                    <td style="width: 7.9%; min-width: 7.9%">
                      {{item.boq_labels}}
                    </td>
                    <td>
                      {{ item.rate |  number : '1.2-2' }}
                    </td>
                    <td>
                      {{item.quantity}}
                    </td>
                    <td>
                      {{item.price}}
                    </td>

                  </tr>
                </tbody>

              </table>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-6">

            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-8 borders border-bottom-0 border-dark">
                  <div class="text">
                    Net Amount
                  </div>

                </div>
                <div class="col-md-4 borders border-left-0 border-bottom-0 border-dark">
                  <div class="text">
                    {{selected_boq_details.net_amount}}

                  </div>

                </div>
                <div class="col-md-8 borders border-bottom-0 border-dark">
                  <div class="text">
                    Discount Applied

                  </div>

                </div>

                <div class="col-md-4 borders border-left-0 border-bottom-0 border-dark">
                  <div class="text" *ngIf="selected_boq_details && selected_boq_details.discount_value">
                    {{selected_boq_details.discount_value}}%
                  </div>
                  <div class="text" *ngIf="selected_boq_details && !selected_boq_details.discount_value">
                    0 %
                  </div>


                </div>

                <div class="col-md-8 borders border-bottom-0 border-dark"
                  *ngIf="selected_boq_details && selected_boq_details.promo_value">
                  <div class="text">
                    Promotion Applied ({{selected_boq_details.promo_code}})
                  </div>
                </div>

                <div class="col-md-4 borders border-left-0 border-bottom-0 border-dark"
                  *ngIf="selected_boq_details && selected_boq_details.promo_value">
                  <div class="text" *ngIf="selected_boq_details && selected_boq_details.promo_value">
                    -{{selected_boq_details.promo_value}}
                  </div>
                  <div class="text" *ngIf="selected_boq_details && !selected_boq_details.promo_value">
                    0
                  </div>
                </div>
                <div *ngIf="selected_boq_details" class="col-md-8 borders border-bottom-0 border-dark">
                  <div class="text">
                    Project Management Fee ( 8% )

                  </div>

                </div>
                <div *ngIf="selected_boq_details" class="col-md-4 borders border-left-0 border-bottom-0 border-dark">
                  <div class="text">
                    {{selected_boq_details.pm_fee}}
                  </div>
                </div>
                <div class="col-md-8 borders border-dark">
                  <div class="text">
                    Total

                  </div>

                </div>
                <div class="col-md-4 borders border-left-0 border-dark">
                  <div class="text">
                    {{selected_boq_details.total_amount}}

                  </div>

                </div>

              </div>

            </div>

          </div>
          <div class="row  borders border-dark mt-5">
            <h6 class="pull-left ml-3 mt-2">Terms and Condition</h6>
            <div class="col-md-12">
              <div class="pull-left text-change">

                1) Prices are subject to the specifications mentioned above. Changes in specifications mentioned above
                shall be charged extra. Prices are inclusive of all taxes, landed at site. Any government levies, is
                payable extra at actual.<br>
                2) Mathadi charge as per actual<br>
                3) Payment Terms: 10% Booking, 40% on Final Design Submission and 50% PDC along with Final Design
                Submission.<br>
                4) Payment Mode: NEFT / RTGS / Cheque<br>
                5) Bank Account Details:
                Account Name: SINGULARITY FURNITURE PRIVATE LIMITED
                Account Number: 02912000003169
                IFSC Code: HDFC0000291
                Bank and Branch: HDFC Bank, Nariman Point Branch<br>

                6) Offer Validity: 30 Days<br>
                7) Order once booked can not be taken back under any circumstances. Advance Amount will not be
                refunded<br>
                8) Safe Storage at Site is client's responsibility<br>
                9) Disputes subject to Mumbai Jurisdiction<br>
                10) Any extra work shall be charged extra<br>
                11) Force Majeure Clause Applies<br>
                12) The seller shall have general lien over on goods for payments due to seller from the buyer on
                account of this<br>
                &emsp;&emsp;or any other PAN Number: AAECP3450G GST Number: 27AAECP3450G1ZJ<br>
                13) Finance Options:<br>
                &emsp;&emsp;Personal Loan : Best ROI: 10.99% Per Lac EMI starting from : INR. 2174 (5 years)<br>
                &emsp;&emsp;Home Loan : Best ROI : 8.35% Per Lac EMI starting from : INR. 858 (20 years)<br>
                &emsp;&emsp;Kindly inform our designer if you wish to avail any loan facility.<br>
                14) Consent note:<br>
                &emsp;&emsp;Singularity Furniture Private Ltd. (Arrivae) has tied up with Rupeeboss Financial Services
                Private Ltd. to offer loan <br>
                &emsp;&emsp;facility on its products and services.<br> &emsp;&emsp;I, hereby, authorise Arrivae to share
                my contact details with Rupeeboss and
                authorise Rupeeboss to contact me <br> &emsp;&emsp;for availing loan facility.<br><br>
                <span style="float:right">- Signature of Customer/ Acceptance tick box</span>

              </div>

            </div>

          </div>
          <div class="row borders border-dark mt-3">
            <h6 class="pull-left ml-3 mt-2">{{selected_boq_details.delivery_tnc}} </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="loading d-block justify-content-center" *ngIf="loader">
  <div class="spinner-border" style="color: #8d0528;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<!--  -->


// WEBPACK FOOTER //
// ./src/app/platform/lead/boq/boq.component.html